import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';
import PropTypes, { object } from 'prop-types';

import { CustomTooltip } from '../parts/parts';

import { textToDateM } from 'utils/common';
import { tick } from '../helpers/config';

const Chart = ({ data, config }) => {
  const formatter = value => (value !== 'auto' ? textToDateM(value) : '');

  return (
    <ResponsiveContainer width="100%" height={312}>
      <LineChart
        data={data}
        margin={{
          top: 4,
          right: 0,
          left: -34,
          bottom: 0
        }}
      >
        <CartesianGrid vertical={false} stroke="#dde6f2" />
        <XAxis
          dataKey="date"
          tick={tick}
          axisLine={false}
          tickLine={false}
          padding={{ left: 32, right: 32 }}
          tickCount={data.length}
          minTickGap={1}
          tickFormatter={formatter}
        />
        <YAxis
          tickCount={10}
          scale="linear"
          domain={[0, 10]}
          tick={tick}
          axisLine={false}
          tickLine={false}
          minTickGap={1}
        />
        {data.length !== 0 && <Tooltip content={<CustomTooltip />} />}
        {config.map(item => {
          return (
            item.value && (
              <Line
                key={item.name}
                type="linear"
                dataKey={item.name}
                stroke={item.color}
                dot={{
                  fill: item.color,
                  stroke: 'white',
                  strokeWidth: 2,
                  r: 4
                }}
                isAnimationActive={false}
                strokeWidth={2}
                connectNulls
              />
            )
          );
        })}
      </LineChart>
    </ResponsiveContainer>
  );
};

Chart.propTypes = {
  data: PropTypes.arrayOf(object),
  config: PropTypes.arrayOf(object)
};

export default Chart;
